<template>
    <div id="e3"
         style="max-width: 400px; margin: auto;"
         class="grey lighten-3">
        <v-toolbar :color="barColor"
                   dark>
            <v-toolbar-title>{{bagTitle}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon>{{toolbarIcon}}</v-icon>
        </v-toolbar>

        <v-card color="blue-grey lighten-3" class="mx-auto">
            <v-container fluid
                         grid-list-lg v-if="!localIsLoading" class="orders-layout">
                <v-layout row wrap v-for="(t, index) in tickets.cards" :key="`${index}`">
                    <v-flex xs12>
                        <v-card class="mx-auto">
                            <v-toolbar color="blue" dark>
                                <v-btn icon v-if="goToLeft" @click="left(t)">
                                    <v-icon>arrow_back</v-icon>
                                </v-btn>
                                <v-toolbar-title> Job Id: {{ t.idTravel }}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon v-if="goToRight" @click="right(t)">
                                    <v-icon>arrow_forward</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <div class="text--primary">
                                        <v-icon class="icon-card">fas fa-calendar-alt</v-icon> Date</div>
                                        <div class="subTitle-card"> {{t.travel.date}} </div>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <div class="text--primary">
                                        <v-icon class="icon-card">far fa-clock</v-icon> Start Time
                                        </div>
                                        <div class="subTitle-card"> {{t.startTime}} </div>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <div class="text--primary" v-if="t.travel.travelDetail.description">
                                   <v-icon class="icon-card">fas fa-file-alt</v-icon> Description
                                </div>
                                <div class="subTitle-card"> {{t.travel.travelDetail.description}} </div>
                                <v-divider></v-divider>
                                <div class="text--primary">
                                   <v-icon class="icon-card">fas fa-map-marker-alt</v-icon> Location
                                </div>
                                <div class="subTitle-card"> {{t.travel.location}} </div>
                                <v-divider></v-divider>
                                <div class="text--primary">
                                   <v-icon class="icon-card pl-3 pr-3">fas fa-user-tag</v-icon> Client Name
                                </div>
                                <div class="subTitle-card"> {{t.travel.customer.name}} </div>
                                <v-divider></v-divider>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6" v-if="t.travel.travelDetail.po">
                                        <div class="text--primary" >
                                        <v-icon class="icon-card pt-2 pl-2 pr-3" >fas fa-hashtag</v-icon> PO
                                        </div>
                                        <div class="subTitle-card"> {{t.travel.travelDetail.po}} </div>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" v-if="t.travel.travelDetail.trucking_Co">
                                        <div class="text--primary" >
                                        <v-icon class="icon-card pt-3">fas fa-building</v-icon> Trucking CO
                                        </div>
                                        <div class="subTitle-card"> {{t.travel.travelDetail.trucking_Co}} </div>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6" v-if="t.travel.travelDetail.truck">
                                        <div class="text--primary" >
                                        <v-icon class="icon-card pt-2 pr-3 pl-3 "    >fas fa-truck</v-icon>Truck
                                        </div>
                                        <div class="subTitle-card"> {{t.travel.travelDetail.truck}} </div>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" v-if="t.travel.travelDetail.trailer">
                                        <div class="text--primary" >
                                        <v-icon class="icon-card pt-2 pr-3 pl-4">fas fa-truck-moving</v-icon> Trailer
                                        </div>
                                        <div class="subTitle-card"> {{t.travel.travelDetail.trailer}} </div>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <div class="text--primary" v-if="t.travel.travelDetail.driver">
                                   <v-icon class="icon-card"    >fas fa-user</v-icon> Driver
                                </div>
                                <div  class="subTitle-card"> {{t.travel.travelDetail.driver}} </div>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <div class="text-center">
                                    <v-btn class="ma-2" tile outlined color="success" :to="'/kanban/task/'+t.idTravel+'/travelWorker/'+t.idTravelWorker">
                                    Edit<v-icon class="pl-3" left>fas fa-clipboard-check</v-icon>
                                </v-btn>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
            <div class="text-xs-center" v-else>
                <v-progress-linear indeterminate :color="progressColor" :size="70" :width="7"></v-progress-linear>
            </div>
        </v-card>
    </div>
</template>

<script>
import {showMessageError,showMessageSuccess,showMessageWarning} from '../../services/sweetAlert'
import { format } from 'date-fns'
export default {
    name:'swammping',
    data() {
        return {
            localIsLoading: false,
            dialogGestion: false,
        }
    },
    props:{
        bagTitle: String,
        toolbarIcon: String,
        barColor: String,
        barAPI: String,
        progressColor: String,
        goToLeft: Boolean,
        goToRight: Boolean,
        id: String,
        tickets: Object,
        isLoading: Boolean
    },
    methods: {
         move(nextMove, tkt) {
            //console.log('move next ', nextMove)
            //console.log('move next 2', tkt)
        },

        left(travel) {
            ////console.log('t ==> ',idTravel)
            this.moveTicket(travel.idTravel,travel.idTravelWorker,'moveTicket')
        },

        right(travel) {
            ////console.log('t ==> ',idTravel)
            this.moveTicket(travel.idTravel,travel.idTravelWorker,'moveTicket')
        },
        async moveTicket(idTravel, idTravelWorker,place){
            this.localIsLoading = true
            var data = {idTravel: idTravel,idTravelWorker: idTravelWorker}
           const response = await this.$store.dispatch(place,data)
           if(response.status === 200){
               this.$emit('elementMoved')
           }else{
               showMessageError('an error occurred')
           }
           this.localIsLoading  =false
        },
        processColor(processInitials) {
            switch (processInitials) {
                case "CI": return "purple darken-4";
                case "CIW": return "brown lighten-2";
                case "RCI": return "deep-purple lighten-2";
                default: return "blue-grey lighten-2";
            }
        },

        dateFormat(value) {
            return format(value, 'DD-MM-YYYY')
        }
    }
}
   
</script>

<style scoped>
    .orders-layout {
        height: 540px;
        overflow: auto;
    }
    .subTitle-card {
        margin-left: 22px;
    }
    .icon-card {
        max-width: 20px;
        max-height: 20px;
    }
</style>